import { useState, useEffect } from 'react';

export function useHash() {
  const [hash, setHash] = useState(() => (typeof window !== 'undefined' ? window.location.hash : ''));

  useEffect(() => {
    const updateHash = () => {
      const currentHash = window.location.hash;
      if (currentHash !== hash) {
        setHash(currentHash);
      }
    };

    const handleScroll = () => {
      requestAnimationFrame(updateHash);
    };

    // we need to listen for scroll to update the hash when using smooth scroll
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('hashchange', updateHash);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('hashchange', updateHash);
      }
    };
  }, [hash]);

  return hash;
}
